<template>
  <div v-if="pending" class="w-100 mt-5 text-center">
    <HMSpinner />
  </div>
  <div v-else>
    <Lessons />
  </div>
</template>

<script lang="ts">
import Lessons from '@/components/product/Lessons.vue';
import {useProductStore} from "~/stores/product";

export default {
  components: {
    Lessons
  },
  async setup() {
    const { $studioURL } = useNuxtApp();
    const route = useRoute();
    const productId = route.params.product_id;

    definePageMeta({
      name: 'studio-product-lessons',

      isStudio: true,
      hideInstagramSlider: true,
      hideProductHeaderImage: true,
      hideMobileNav: true,
    });

    const { pending } = useLazyAsyncData('productLessons', () => useProductStore().getProductLessons({
      studioURL: $studioURL,
      productId,
    }));

    return {
      pending
    }
  },
};
</script>